export default __webpack_public_path__ + "static/InsightFeatureFour-12cd53d6992fc8b1bd86f0d369355607.webp";